import type { ImportReadiness } from "./import-readiness";

export type ImportSummaryPhase =
  | "vendors"
  | "vendors-table"
  | "dates"
  | "blockers"
  | "warnings"
  | "ready";

export function deriveImportSummaryPhase(
  readiness: ImportReadiness,
  hasVendorMapping: boolean,
  blockingIssueCount: number,
): ImportSummaryPhase {
  if (!readiness.steps.vendors) {
    return hasVendorMapping ? "vendors" : "vendors-table";
  }
  if (!readiness.steps.dates) {
    return "dates";
  }
  if (blockingIssueCount > 0) {
    return "blockers";
  }
  if (!readiness.steps.issues) {
    return "warnings";
  }
  return "ready";
}

export function progressStepNumber(phase: ImportSummaryPhase): number {
  switch (phase) {
    case "vendors":
    case "vendors-table":
      return 1;
    case "dates":
      return 2;
    case "blockers":
    case "warnings":
    case "ready":
      return 3;
  }
}

export type ProgressStepId = "vendors" | "dates" | "issues";

export function progressStepState(
  stepId: ProgressStepId,
  readiness: ImportReadiness,
): "done" | "current" | "upcoming" {
  if (stepId === "vendors") {
    if (readiness.steps.vendors) return "done";
    return "current";
  }
  if (stepId === "dates") {
    if (readiness.steps.dates) return "done";
    if (!readiness.steps.vendors) return "upcoming";
    return "current";
  }
  if (readiness.steps.issues) return "done";
  if (!readiness.steps.dates) return "upcoming";
  return "current";
}
